import React, { useState } from 'react';
import divider from '../../assets/divider-img.png';
import msg from '../../assets/contact-items/msg.png';
import linkedin from '../../assets/contact-items/linkedin.png';
import twitter from '../../assets/contact-items/twitter.png';
import discord from '../../assets/contact-items/discord.png';
// import { db } from '../../../firebase';

const ContactForm = () => {
  const [name, setName] = useState('');
  const [lastname, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    // db.collection('contacts')
    //   .add({
    //     firstName: name,
    //     lastName: lastname,
    //     email: email,
    //     subject: subject,
    //     message: message,
    //   })
    //   .then(() => {
    //     alert('Form Submitted Successfully');
    //   })
    //   .catch((error) => {
    //     alert(error.message);
    //   });

    setName('');
    setLastName('');
    setEmail('');
    setSubject('');
    setMessage('');
  };
  return (
    <div>
      <div className="container">
        <div className="center-heading-description heading-width">
          <h2>Feel Free Contact Us Toady And Get Your Solution</h2>
          <div className="divider">
            <img src={divider} alt="divider" />
          </div>
          <p>
            Our dedicated team is ready to respond promptly and provide the
            guidance you need. Your financial success begins with a simple
            contact.
          </p>
        </div>
        <div className="contact-form-wrapper">
          <div className="contact-form-left">
            <div className="msgbox-div m-b">
              <img src={msg} alt="divider" />
            </div>
            <h3 className="m-b">Reach Us</h3>
            <div className="m-b">
              <p>Work and general inquiries </p>
              <p>
                <strong>+1.890.473.5102</strong>
              </p>
            </div>
            <div className="m-b">
              <p>Mail</p>
              <p>
                <strong>company@gmail.com</strong>
              </p>
            </div>
            <div className="contact-socials m-b">
              <img className="m-r-m" src={linkedin} alt="contact-socials" />
              <img className="m-r-m" src={twitter} alt="contact-socials" />
              <img className="m-r-m" src={discord} alt="contact-socials" />
            </div>
          </div>
          <div className="contact-form-right">
            <h3 className="m-b">Get in Touch</h3>
            <p className="m-b">
              Reach out to us through the contact information below, and let's
              start a conversation that could shape your financial future.
            </p>
            <form className="contact-form" onSubmit={handleSubmit}>
              <div className="form-group">
                <input
                  className="m-r"
                  placeholder="First Name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
                <input
                  placeholder="Last Name"
                  value={lastname}
                  onChange={(e) => setLastName(e.target.value)}
                />
              </div>
              <div className="form-group">
                <input
                  className="m-r"
                  placeholder="Email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
                <input
                  placeholder="Subject"
                  value={subject}
                  onChange={(e) => setSubject(e.target.value)}
                />
              </div>
              <div className="form-group">
                <textarea
                  rows="5"
                  placeholder="Your Message"
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                />
              </div>
              <button type="submit">Send Message</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactForm;
